import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

import { OfficeSettingsCard } from "@/features/projects/OfficeSettingsCard";
import { Button } from "@/components/ui/button";

/**
 * Postavke — global, cross-project configuration. The office letterhead
 * (P3) is a SETTING, not a step in the generation flow, so it lives here
 * instead of inline in the project scroll. ``useOfficeStore`` persists it,
 * so the generate request picks it up from every project regardless.
 */
export function PostavkePage() {
  const navigate = useNavigate();
  return (
    <>
      <div className="mb-4 flex items-center justify-between gap-4">
        <div>
          <h2 className="text-[1.05rem] font-bold text-stone-800">Postavke</h2>
          <p className="text-[0.88rem] text-stone-500">
            Zaglavlje ureda i projektant — vrijedi za sve projekte, ulazi u
            generiranu dokumentaciju.
          </p>
        </div>
        <Button variant="ghost" size="sm" onClick={() => navigate("/")}>
          <ArrowLeft className="h-4 w-4" />
          Natrag
        </Button>
      </div>
      <OfficeSettingsCard />
    </>
  );
}
